import { render, staticRenderFns } from "./CheckpointHome.vue?vue&type=template&id=538901c8&scoped=true"
import script from "./CheckpointHome.vue?vue&type=script&lang=js"
export * from "./CheckpointHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538901c8",
  null
  
)

export default component.exports